import { useEffect, useState } from 'react';

/**
 * See https://help.usaepay.info/developer/payjs-v2/
 */
export default function usePaymentCard(usaepayPublicKey?: string) {
  const [usaepayClient] = useState(
    new usaepay.Client(
      usaepayPublicKey ?? import.meta.env.VITE_USAEPAY_PUBLIC_API_KEY,
    ),
  );

  const [paymentCard] = useState(() => usaepayClient.createPaymentCardEntry());
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function getPaymentKey() {
    try {
      const result = await usaepayClient.getPaymentKey(paymentCard);

      if ('error' in result) {
        setErrorMessage(result.error.message);
      } else {
        setErrorMessage(null);
        return result;
      }
    } catch (error) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      } else {
        throw error;
      }
    }
  }

  useEffect(() => {
    function handleError(error: usaepay.PaymentCardError) {
      setErrorMessage(error.message);
    }

    // There is not an equivalent removeEventListener in usaepay.PaymentCardEntry
    paymentCard.addEventListener('error', handleError);
  }, [paymentCard]);

  return { paymentCard, getPaymentKey, errorMessage };
}
